// extracted by mini-css-extract-plugin
module.exports = {"default":"Tab_default__20smA","selected":"Tab_selected__2ojjA"};